"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionnaireResponseItem = void 0;
/**
 * A structured set of questions and their answers. The questions are ordered and grouped into coherent subsets, corresponding to the structure of the grouping of the questionnaire being responded to.
 */
var QuestionnaireResponseItem = /** @class */ (function () {
    function QuestionnaireResponseItem() {
    }
    return QuestionnaireResponseItem;
}());
exports.QuestionnaireResponseItem = QuestionnaireResponseItem;
